<template>
    <div>
        <el-row>
            <el-col>
                <!-- 计数器 -->
                <!--
                    参数：
                     min:设置计数器允许的最小值
                     max:设置计数器允许的最大值
                     step:计数器步长 默认为1
                     precision:数值精度 precision 的值必须是一个非负整数，并且不能小于 step 的小数位数
                     size: 计数器尺寸  可选值large, small
                     disabled:是否禁用计数器
                     controls:是否使用控制按钮
                     controlsPosition:控制按钮位置
                     placeholder:占位符，默认‘请输入’

                     方法：
                      change（在值改变时触发）、blur(失去焦点时触发)、focus（组件获得焦点时触发）、
                -->
                <td-input-number
                    v-model="inputNumber"
                    :min="2"
                    :max="8005"
                    :step="2"
                    size="large"
                    :controls="true"
                    @change="numberChange"
                    @blur="numberBlur"
                    @focus="numberFocus"
                    controlsPosition="right"
                ></td-input-number>
                <td-button @click="btnNumber">点击获取</td-button>
            </el-col>
        </el-row>
        <el-row>
            <!-- 复选框 -->
            <!--
                参数：
                disabled:是否禁用
                border:是否启用边框
                方法：
                change（在值改变时触发）
             -->
            <td-checkbox v-model="checkbox" ref="checkbox" :disabled="disabled" @change="checkboxChange">复选框</td-checkbox>
        </el-row>
        <el-row>
            <!-- switch 开关 -->
            <!--
                activeColor: 打开时的背景色(默认使用默认颜色)
                inactiveColor:关闭时的背景色(默认使用默认颜色)
                activeText：打开时的文字描述
                inactiveText：关闭时的文字描述
                activeValue：打开时的值
                inactiveValue：关闭时的值
                disabled：是否禁用
                width：组件宽度

                方法：
                 change（在值改变时触发）
             -->
            <td-switch v-model="switch1" @change="changeSwitch"></td-switch>
        </el-row>
        <el-row>
            <el-col :span="3">
                <!-- 复选框组 -->
                <!--
                 参数：
                 allList:所有需要创建的check数组
                 checkedList:选中的keys数组
                 keys:id值关键字默认value
                 text：显示文字的关键字 默认label
                 checkAll：是否全选
                 hascheckAll：显示全选框
                 isIndeterminate：设置 indeterminate 状态，只负责样式控制 hascheckAll=true生效
                 border：边框Boolean
                 hasBtn：是否显示button类型按钮
                 hasBasicTypes:是否为基本类型的数据，例如['A','B']形式
                 方法：
                 handleCheckedChange
             -->
                <td-checkbox-group
                    ref="check"
                    :allList="allList"
                    v-model="checkedList"
                    keys="id"
                    text="name"
                    @handleCheckAllChange="handleCheckAllChange"
                    @handleCheckedChange="handleCheckedChange"
                ></td-checkbox-group>
            </el-col>
            <td-button @click="checkAll">全/反选</td-button>
            <td-button @click="checkCounter">反向选择</td-button>
            <td-button @click="halfElection">半选</td-button>
        </el-row>
        <el-row>
            <!-- 选择器 -->
            <!--
                参数：
                keys：下拉框id值关键字
                text：显示文字的关键字
                options：部件的下拉选项数组
                clearable：可将选择器清空。需要注意的是，clearable属性仅适用于单选
                multiple:设置multiple属性即可启用多选 默认情况下选中值会以 Tag 的形式展现,可以设置collapse-tags属性将它们合并为一段文字
                collapseTags：将多选项合并为一段文字
                filterable：是否启用搜索功能
                size：尺寸 medium/small/mini
                multipleLimit：多选时用户最多可以选择的项目数，为 0 则不限制 默认0
                disabled：是否禁用
                autocomplete：自动补全
                noDataText：没有选项时显示文字。默认无数据
                placeholder：默认显示请选择
                pageSize:每页条数
                width：宽度
                hasBasicTypes：是否为基本类型的数据，例如['A','B']形式
                方法：
                change（在值改变时触发）、blur(失去焦点时触发)、focus（组件获得焦点时触发）、
                clear(清空按钮时触发)、visibleChange(下拉框出现/隐藏时触发)、 removeTag(多选模式下移除tag时触发,移除的tag值)
             -->
            <!-- 选择器- -->
            <td-select v-model="select" :options="options" keys="value" text="label" :pageSize="10"></td-select>
            <td-button @click="btnSelect">点击查看</td-button>
        </el-row>
        <el-row>
            <!-- 穿梭框 -->
            <!--
                参数：
                data：数据源
                props：数据源的字段别名 {key: 'key', label: 'label'}
                disabledList：禁用信息 key值
                leftDefaultChecked：初始状态下左侧列表的已勾选项的 key 数组
                rightDefaultChecked：初始状态下右侧列表的已勾选项的 key 数组
                filterable：是否启用搜索框
                placeholder：默认显示搜索框占位符 默认‘请输入’
                titles：自定义表头文案
                buttonTexts：自定义按钮文案
                方法：
                change（列表元素变化时触发 当前值、数据移动的方向（'left' / 'right'）、发生移动的数据 key 数组）
                leftCheckChange（左侧列表元素被用户选中 / 取消选中时触发  当前被选中的元素的 key 数组、选中状态发生变化的元素的 key 数组）
                rightCheckChange（右侧列表元素被用户选中 / 取消选中时触发  当前被选中的元素的 key 数组、选中状态发生变化的元素的 key 数组）
                getAllRightKeys（获取所有右侧数据）
             -->
            <td-transfer
                v-model="transfer"
                ref="transfer"
                :permissions="permissions"
                :data="data"
                :props="props"
                :disabledList="disabledList"
                :buttonTexts="buttonTexts"
                @change="changeTransfer"
            ></td-transfer>
        </el-row>
        <el-row>
            <!-- 上传组件 -->
            <!--
                actionUrl：必选参数，上传的地址
                multiple：是否支持多选文件
                limit：最大允许上传个数
                showFileList：是否显示已上传文件列表
                drag：是否启用拖拽上传
                accept：接受上传的文件类型（thumbnail-mode 模式下此参数无效）
                listType:文件列表的类型    text/picture/picture-card
                disabled:是否禁用
                autoUpload:是否在选取文件后立即进行上传
                message:上传文件说明

                使用拖拽上传可调用方法手动上传文件

                方法：
                submitUpload：手动上传（需要手动调用的方法）
                handleRemove：文件列表移除文件时的钩子
                handlePreview：点击文件列表中已上传的文件时的钩子
                handleExceed：文件超出限制的钩子
                beforeRemove：移除文件前进行调用
                handSuccess：文件上传成功时的钩子
                handError：文件上传失败时的钩子
                handChange：文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
             -->
            <td-upload :multiple="false" :actionUrl="actionUrl" ref="upload" :showFileList="true" @handleRemove="handleRemove" @handResponse="handResponse"></td-upload>
        </el-row>
        <el-row>
            <!-- 权限标签
                permissions：满足所有权限
                roles：角色
                oneOfPermissions：满足权限之一
                havePermission：有权限时显示组件位置
                noPermission：有权限时显示组件位置
             -->
            <td-permission :permissions="permissions" :roles="roles" :oneOfPermissions="oneOfPermissions">
                <div slot="havePermission">
                    <td-button>有权限显示</td-button>
                </div>
                <div slot="noPermission">
                    <td-button type="primary">没权限显示</td-button>
                </div>
            </td-permission>
        </el-row>
        <el-row>
            <!--
                options:数据源Array类型， 包括绑定对象，显示名称，是否禁用 ，
                keys：绑定值关键字,基本数据类型或者绑定对象类型可不定义 默认value
                text：显示名称关键字，如基本数据类型可不定义，例如options= ["AAA","BBB"] 默认label
                border：是否显示边框
                size：大小
                hasBtn：是否为按钮类型
                hasBasicTypes：是否绑定为基本类型类型
             -->
            <td-radio v-model="radio" :options="optionsRadio"></td-radio>
            <td-button @click="getRadio">获取</td-button>
        </el-row>
    </div>
</template>
<script>
export default {
    data() {
        return {
            permissions: ['userInfo:view', 'userInfo:add'],
            roles: ['admin'],
            oneOfPermissions: ['userInfo:view'],
            inputNumber: '',
            checkbox: '',
            disabled: false,
            allList: [
                {
                    id: 'id1',
                    name: '1(最高)'
                },
                {
                    id: 'id2',
                    name: '2',
                    isIndeterminate: false
                },
                {
                    id: 'id2',
                    name: '3',
                    isIndeterminate: false
                },
                {
                    id: 'id2',
                    name: '4',
                    isIndeterminate: false
                },
                {
                    id: 'id2',
                    name: '5',
                    isIndeterminate: false
                }
            ],
            checkedList: ['id1'],
            switch1: '',
            select: '选项1',
            transfer: ['id2'],
            options: [
                {
                    value: '选项1',
                    label: '选项1'
                },
                {
                    value: '选项2',
                    label: '选项2'
                },
                {
                    value: '选项3',
                    label: '选项3'
                },
                {
                    value: '选项4',
                    label: '选项4'
                },
                {
                    value: '选项5',
                    label: '选项5'
                },
                {
                    value: '选项6',
                    label: '选项6'
                },
                {
                    value: '选项7',
                    label: '选项7'
                },
                {
                    value: '选项8',
                    label: '选项8'
                },
                {
                    value: '选项9',
                    label: '选项9'
                },
                {
                    value: '选项10',
                    label: '选项10'
                },
                {
                    value: '选项11',
                    label: '选项11'
                },
                {
                    value: '选项12',
                    label: '选项12'
                },
                {
                    value: '选项13',
                    label: '选项13'
                },
                {
                    value: '选项14',
                    label: '选项14'
                },
                {
                    value: '选项15',
                    label: '选项16'
                },
                {
                    value: '选项17',
                    label: '选项17'
                }
            ],
            data: [
                {
                    id: 'id1',
                    name: '选项1'
                },
                {
                    id: 'id2',
                    name: '选项2'
                },
                {
                    id: 'id3',
                    name: '选项3'
                }
            ],
            props: { key: 'id', label: 'name' },
            disabledList: [
                {
                    id: 'id1',
                    name: '选项1'
                }
            ],
            checkedCities: '',
            buttonTexts: ['向左', '向右'],
            actionUrl: '/aaa/bbb',
            radio: true,
            optionsRadio: [{ value: true, label: '选项1' }, { value: false, label: '选项2' }]
        };
    },
    methods: {
        /* inputNumber 相关 */

        // 数据改变时回调
        numberChange(val) {},
        handResponse(response, file, fileList) {},
        // 获得焦点时回调
        numberFocus(event) {},
        // 失去焦点时回调
        numberBlur(event) {},
        // 获取当前数据
        btnNumber() {
            this.$message({ message: this.inputNumber, type: 'success' });
        },

        /* 复现框相关 */

        /* 状态变化时回调 */
        checkboxChange(value) {},
        /* 获取复选框状态 */
        getcheckboxValue() {
            /* 第一种 */
            this.$message({ message: this.check, type: 'success' });
            /* 第二种 */
            this.$message({ message: this.$refs.checkbox.getValue(), type: 'success' });
        },
        /* 复选框组相关 */

        /* 全选功能 */
        checkAll() {
            this.$refs.check.checkAllSet();
        },
        /* 反选功能 */
        checkCounter() {
            this.$refs.check.counterSelection();
        },
        halfElection() {
            this.allList[1].isIndeterminate = true;
        },
        /* 全选时回调 */
        handleCheckAllChange(val) {},
        /* 选中变化回调 checkNewest 当前最新选中的对象 value为所有选中的对象 */
        handleCheckedChange(value, checkNewest) {},
        /* switch滑块 */
        changeSwitch(value) {},
        /* selct */
        changeSelect(val) {},
        btnSelect() {
            alert(this.select);
        },
        /* 穿梭框相关 */
        /* 变化回调 */
        changeTransfer(value, direction, moveArray) {},
        /* 获取所有右侧数据 key值集合 */
        getAllRightKeys() {
            this.$refs.transfer.getAllRightKeys();
        },
        /* 上传组件相关 */

        /* 手动上传文件 */
        submitUpload() {
            this.$refs.upload.submitUpload();
        },
        /* 文件列表移除文件时的钩子 */
        handleRemove(file, fileList) {},
        /* radio相关 */
        getRadio() {
            alert(this.radio);
        }
    },
    beforeDestroy() {
        this.options = null;
    }
};
</script>
